import { createTheme } from '@mui/material/styles';

// Premium light theme tailored for a professional portfolio
const theme = createTheme({
  palette: {
    mode: 'light',
    primary: {
      main: '#0f172a', // slate-900 (bold dark for buttons and primary elements)
      light: '#334155', // slate-700
      dark: '#020617', // slate-950
    },
    secondary: {
      main: '#3b82f6', // blue-500 accent for highlights
      light: '#60a5fa', // blue-400
    },
    background: {
      default: '#f8fafc', // slate-50 (very soft light gray for main body)
      paper: '#ffffff',   // pure white for cards
    },
    text: {
      primary: '#0f172a',   // slate-900
      secondary: '#475569', // slate-600
    },
    action: {
      hover: 'rgba(15, 23, 42, 0.04)', // subtle hover
    },
  },
  shape: {
    borderRadius: 16,
  },
  typography: {
    fontFamily: [
      'Inter',
      '-apple-system',
      'BlinkMacSystemFont',
      '"Segoe UI"',
      'Roboto',
      '"Helvetica Neue"',
      'Arial',
      'sans-serif',
    ].join(','),
    h1: { fontWeight: 800, letterSpacing: '-0.03em' },
    h2: { fontWeight: 800, letterSpacing: '-0.025em' },
    h3: { fontWeight: 700, letterSpacing: '-0.025em' },
    h4: { fontWeight: 700, letterSpacing: '-0.02em' },
    h5: { fontWeight: 600 },
    h6: { fontWeight: 600 },
    subtitle1: { fontWeight: 500 },
    button: { textTransform: 'none', fontWeight: 600 },
    body1: { lineHeight: 1.7 },
  },
  components: {
    MuiButton: {
      styleOverrides: {
        root: {
          borderRadius: 8,
          padding: '10px 24px',
          boxShadow: 'none',
        },
        contained: {
          boxShadow: '0 4px 6px -1px rgba(0, 0, 0, 0.1), 0 2px 4px -1px rgba(0, 0, 0, 0.06)',
          '&:hover': {
            boxShadow: '0 10px 15px -3px rgba(0, 0, 0, 0.1), 0 4px 6px -2px rgba(0, 0, 0, 0.05)',
            transform: 'translateY(-1px)',
            backgroundColor: '#1e293b', // slate-800
          },
          transition: 'all 0.2s ease-in-out',
        },
        outlined: {
          borderWidth: 2,
          '&:hover': {
            borderWidth: 2,
            backgroundColor: 'rgba(59, 130, 246, 0.04)',
          }
        }
      },
    },
    MuiCard: {
      styleOverrides: {
        root: {
          boxShadow: '0 4px 6px -1px rgba(0, 0, 0, 0.05), 0 2px 4px -1px rgba(0, 0, 0, 0.03)',
          border: '1px solid rgba(0,0,0,0.05)',
          borderRadius: 16,
          transition: 'transform 0.3s ease, box-shadow 0.3s ease',
          '&:hover': {
            transform: 'translateY(-4px)',
            boxShadow: '0 20px 25px -5px rgba(0, 0, 0, 0.1), 0 10px 10px -5px rgba(0, 0, 0, 0.04)',
          }
        },
      },
    },
    MuiChip: {
      styleOverrides: {
        root: {
          fontWeight: 600,
          borderRadius: 8,
        },
        outlined: {
          backgroundColor: 'rgba(255, 255, 255, 0.6)',
          backdropFilter: 'blur(4px)',
          border: '1px solid rgba(15, 23, 42, 0.12)',
        }
      }
    }
  },
});

export default theme;
